import { fetchRetry, render } from "../../assets/js/utils.js";
import { toggleHinweis } from "../../modules/hinweis/hinweis.js";

class AutorTeaserBootstrap extends HTMLElement {
    constructor() {
        super();
        this.uri = `${this.baseUrl}/autorenportrait/v1/${this.matNr}/content`;
        this.ladespinner = this.querySelector(".ladespinner");
        this.start();
    }

    get matNr() {
        return this.dataset["productId"];
    }

    get baseUrl() {
        const baseurl = this.dataset["baseurl"];
        if (!baseurl) {
            return "";
        }
        return baseurl;
    }

    disconnectedCallback() {
        this.disconnect();
    }

    start() {
        this.observer = this.initObserver();
        this.addAnchorScrollListener();
    }

    disconnect() {
        this.observer.disconnect();
    }

    addAnchorScrollListener() {
        // Wir hören auf zwei Events (start, finish) des Custom Elements <scroll-to-anchor> (Artikeldetailseite),
        // um plötzliches Stoppen der Seite beim Scrollen (Anker) zu vermeiden. Siehe dazu auch:
        // https://hd.thalia.de/jira/browse/SBE-8411
        // https://hd.thalia.de/jira/browse/SBE-7432
        document.addEventListener("sbe.anchorScroll.start", (event) => {
            this.disconnect();
        }, { once: true });
        document.addEventListener("sbe.anchorScroll.finish", (event) => {
            this.start();
        }, { once: true });
    }

    initObserver() {
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                this.observeTeaser(entry);
            }
        });
        observer.observe(this);
        return observer;
    }

    observeTeaser(entry) {
        if (entry.isIntersecting) {
            this.initTeaser();
        }
    }

    async initTeaser() {
        try {
            const response = await fetchRetry(this.uri, {}, 3, 2000);
            const html = await response.text();
            render(this, html, true);
        } catch (error) {
            this.hideLadespinner();
            toggleHinweis(this, {
                mode: "blocking",
                text: "Es ist ein Problem aufgetreten. Das Portrait des Autors konnte nicht geladen werden.",
                type: "warning"
            });
        } finally {
            this.disconnect();
        }
    }

    hideLadespinner() {
        this.ladespinner.removeAttribute("data-status");
    }
}

customElements.get("autor-teaser-bootstrap") || customElements.define("autor-teaser-bootstrap", AutorTeaserBootstrap);
